<template>
  <div class="container">
    <div class="top-wrapper">
      <img class="top-img" :src="topImg" />
      <div class="name-box">
        <div class="name-sub">Contact Us</div>
        <div class="name-ch">联系我们</div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="contact-section">
        <div class="section-title">联系我们</div>
        <div class="contact-section-body">
          <dic class="contact-left">
            <div class="contact-desc">
              如有任何疑问或需要帮助，我们专业的客服团队将竭诚为您服务。无论您对预订有任何疑问、需要建议，还是在使用中需要支持，我们都将全天候为您服务。欢迎通过以下方式联系我们：
            </div>
            <div class="localtion">
              <img class="icon icon-localtion" src="@/assets/location.png" />
              <span
                >OPULRICH PTE. LTD.3 FRASER STREET #04-23A DUO TOWER SINGAPORE
                (189352)</span
              >
            </div>
            <div class="phone">
              <img class="icon icon-phone" src="@/assets/phone.png" />
              <span>+65 88079862</span>
            </div>
            <div class="email">
              <img class="icon icon-email" src="@/assets/email.png" />
              <span>amy@opulrich.com.sg</span>
            </div>
            <div class="contact-desc-sub">
              我们致力于为您提供最好的服务，确保您美好的产品体验。
            </div>
          </dic>
          <img class="contact-right" :src="centerImg" />
        </div>
      </div>

      <div class="certificate-section">
        <div class="section-title">证书及奖项</div>
        <div class="certificate-box">
          <div
            class="certificate-item"
            v-for="(item, index) in cerList"
            :key="index"
          >
            <img class="certificate-img" :src="item.url" />
            <div class="certificate-name">{{ item.title }}</div>
            <div class="certificate-name-sub">
              {{ item.subTitle }}
            </div>
          </div>
        </div>

        <!-- <div class="award-box">
          <div
            class="award-item"
            v-for="(item, index) in awardList"
            :key="index"
          >
            <img class="award-img" :src="item.url" />
            <div class="award-name">{{ item.title }}</div>
            <div class="award-name-sub">{{ item.subTitle }}</div>
          </div>
        </div> -->
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageFooter from '@/components/common/page-footer/page-footer.vue'
export default {
  name: 'home',
  components: {
    pageFooter
  },
  data() {
    return {
      topImg: require('@/assets/contact1.png'),
      centerImg: require('@/assets/contact2.png'),
      cerList: [
        // {
        // 	url: require('@/assets/contact/1.png'),
        // 	title: "新加坡2024年最信赖品牌奖",
        // 	subTitle: "SINGAPAORE TRUSTED BRAND 2024"
        // },
        // {
        // 	url: require('@/assets/contact/2.png'),
        // 	title: "新加坡2024年顾客首选奖",
        // 	subTitle: "SINGAPORE FIRST CONSUMER CHOICE 2024",
        // },
        // {
        // 	url: require('@/assets/contact/3.png'),
        // 	title: "新加坡2024年诚信企业奖",
        // 	subTitle: "2024 BUSINESS TRUST",
        // },
        {
          url: require('@/assets/contact/4.png'),
          title: '2024新加坡食品进口许可证',
          subTitle: '2024 SINGAPORE FOOD AGENCY'
        },
        {
          url: require('@/assets/contact/5.png'),
          title: '香港 STC 产品测试标志证书',
          subTitle: 'Hong Kong STC tested mark certificate for product'
        },
        {
          url: require('@/assets/contact/6.png'),
          title: '香港 STC 检测标志证书 黄秋葵饮料',
          subTitle:
            'Hong Kong STC tested mark certificate for product Okra-drink'
        },
        {
          url: require('@/assets/contact/7.png'),
          title: '香港STC检测标志证书 花生肽产品',
          subTitle:
            'Hong-Kong STC tested mark certificate for product Peanut peptides'
        },
        // {
        //   url: require('@/assets/contact/8.png'),
        //   title: '提高活性多糖含量黄秋葵种植技术专利',
        //   subTitle:
        //     'Patent for okra cultivation technology to increase active polysaccharide content'
        // },
        // {
        //   url: require('@/assets/contact/9.png'),
        //   title: '水酶法提取花生肽专利',
        //   subTitle:
        //     'Patent for the aqueous enzymatic extraction of peanut peptides'
        // },
        {
          url: require('@/assets/contact/10.png'),
          title: 'NMN SGS 测试报告',
          subTitle: 'SGS TEST REPORT ON NMN'
        }
        // {
        //   url: require('@/assets/contact/11.png'),
        //   title: '新加坡金品牌',
        //   subTitle: 'Singapore Golden Brand'
        // },
        // {
        //   url: require('@/assets/contact/12.png'),
        //   title: '亚洲最具影响力品牌',
        //   subTitle: 'Asias most influential brand'
        // }
      ],
      awardList: [
        {
          url: require('@/assets/contact/13.png'),
          title: 'NMN SGS 测试报告',
          subTitle: 'SGS TEST REPORT ON NMN'
        },
        {
          url: require('@/assets/contact/14.png'),
          title: '新加坡金品牌',
          subTitle: 'Singapore Golden Brand'
        },
        {
          url: require('@/assets/contact/15.png'),
          title: '亚洲最具影响力品牌',
          subTitle: 'Asias most influential brand'
        },
        {
          url: require('@/assets/contact/16.png'),
          title: '葵博士台州市著名商标',
          subTitle: 'Dr. Kui is a famous brand in Taizhou City'
        },
        {
          url: require('@/assets/contact/17.png'),
          title: '无公害农产品证书 农韵黄秋葵',
          subTitle:
            'Pollution-free agricultural product certificate Nongyun okra'
        },
        {
          url: require('@/assets/contact/18.png'),
          title: '有机产品认证证书 种植',
          subTitle: 'Organic product certification'
        },
        {
          url: require('@/assets/contact/19.png'),
          title: '无公害产品 产地认定证书',
          subTitle: 'Pollution-free product origin certification'
        },
        {
          url: require('@/assets/contact/20.png'),
          title: '浙江省 无公害农产品基地',
          subTitle:
            'Zhejiang Province Pollution-free Agricultural Products Base'
        },
        {
          url: require('@/assets/contact/21.png'),
          title: '黄秋葵含片发明专利证书',
          subTitle: 'Okra lozenge invention patent certificate'
        },
        {
          url: require('@/assets/contact/22.png'),
          title: '台州市专利示范企业',
          subTitle: 'Taizhou Patent Demonstration Enterprise'
        },
        {
          url: require('@/assets/contact/23.png'),
          title: '纽约科学院会员',
          subTitle: 'Member of the New York Academy of Sciences'
        },
        {
          url: require('@/assets/contact/24.png'),
          title: '亚洲最具影响力品牌',
          subTitle: 'Asias most influential brand'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  text-align: left;
}

.top-wrapper {
  position: relative;

  .top-img {
    width: 100%;
    height: 1080px;
  }

  .name-box {
    position: absolute;
    top: 30%;
    transform: translateY(-50%);
    left: 10%;
    color: #fff;
    text-align: left;

    display: flex;
    flex-direction: column;
    display: inline;

    .name-sub {
      position: relative;
      font-size: 12px;
      text-align: left;
      padding: 0 16px;
      width: 75px;

      &::before {
        position: absolute;
        content: '';
        height: 1px;
        width: 15px;
        top: 50%;
        transform: translateY(-50%);
        left: -2px;
        background: #fff;
      }

      &::after {
        position: absolute;
        content: '';
        height: 1px;
        width: 15px;
        top: 50%;
        transform: translateY(-50%);
        right: -2px;
        background: #fff;
      }
    }

    .name-ch {
      margin-top: 10px;
      font-weight: bold;
      font-size: 26px;
    }
  }
}

.content-wrapper {
  width: 60%;
  margin: auto;
  margin-top: 30px;

  .contact-section {
    color: #333;

    .contact-section-body {
      margin-top: 30px;
      display: flex;

      .contact-left {
        background-color: #f8f8f8;
        padding: 20px;

        .contact-desc {
          font-size: 14px;
          line-height: 20px;
        }

        .contact-desc-sub {
          font-size: 13px;
          margin-top: 30px;
        }

        .localtion {
          margin-top: 20px;
          display: flex;
          align-items: center;
          font-weight: bold;

          .icon {
            margin-right: 20px;
            width: 16px;
            height: 16px;
          }
        }

        .phone {
          margin-top: 20px;
          display: flex;
          align-items: center;
          font-weight: bold;

          .icon {
            margin-right: 20px;
            width: 16px;
            height: 16px;
          }
        }

        .email {
          display: flex;
          align-items: center;
          font-weight: bold;
          margin-top: 20px;

          .icon {
            margin-right: 20px;
            width: 16px;
            height: 16px;
          }
        }
      }

      .contact-right {
        margin-left: 20px;
        height: 350px;
      }
    }
  }

  .certificate-section {
    margin-top: 30px;

    .section-title {
    }

    .certificate-box {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      row-gap: 10px;
      column-gap: 10px;
      margin-top: 30px;

      .certificate-item {
        box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.04);
        text-align: center;
        padding-bottom: 20px;

        .certificate-img {
          width: 100%;
          height: 500px;
          background-color: #f8f8f8;
          border: 1px solid #f8f8f8;
        }

        .certificate-name {
          margin-top: 10px;
          font-size: 18px;
          color: #333333;
          font-weight: bold;
          padding: 10px 0 20px 5px;
        }

        .certificate-name-sub {
          word-break: break-word;
        }
      }
    }

    .award-box {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      row-gap: 10px;
      column-gap: 10px;
      margin-top: 30px;

      .award-item {
        box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.04);
        text-align: center;
        padding-bottom: 20px;

        .award-img {
          width: 100%;
          height: 300px;
          background-color: #f8f8f8;
          border: 1px solid #f8f8f8;
        }

        .award-name {
          margin-top: 10px;
          font-size: 18px;
          color: #333333;
          font-weight: bold;
          padding: 10px 0 20px 5px;
        }

        .award-name-sub {
          word-break: break-word;
        }
      }
    }
  }
}

.section-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  position: relative;
  height: 30px;

  &:before {
    position: absolute;
    content: '';
    left: 0;
    width: 50px;
    height: 4px;
    background-color: #3e8cef;
    bottom: -10px;
  }
}
</style>
